import type {SlotGameStore, BaseComponentConfig, BitmapText} from "@gamzix/slot_core";

import {CONST} from "../../../src/const";

class CoinAnimationComponent extends SlotGame.src.component.BaseComponent {

    static events = {
        FLY_FINISH: "CoinAnimationComponent.FLY_FINISH",
        FLY_START: "CoinAnimationComponent.FLY_START",
    }

    protected TIME_MOVE = 250;
    protected TIME_DELAY_BEFORE_MOVE = 250;

    protected totalWin = 0;
    protected isShowing = false;
    protected totalWinCounter;

    protected reelset;

    constructor(config: BaseComponentConfig) {
        super(config);

        this.status_checkers = {
            ...super.getStatusCheckers(),

            isShowing: () => this.isShowing
        }
    }

    onGameReady() {
        super.onGameReady();

        //@ts-ignore
        this.reelset = game.component.reelset;

        this.totalWinCounter = game.tree.findByName('ui.win_label');
    }

    async playCoinAnimation(label, {time, fromElement, onStart, onFinish}) {
        function  setOverlayImage(textureName, view) {
            const overlayView:any = game.builder.create({type: "Sprite", texture: textureName, scale: {x: 1, y:1}});
            overlayView.options.visible = false;
            overlayView.updateViewOptions();
            view.addChild(overlayView);

            return overlayView;
        }

        let text;

        if(["gold", "silver", "bronze"].includes(label)){
            text = setOverlayImage(`coin_${label}`, this.view);
        } else {
            text = <BitmapText>game.builder.create(this.options.config.coinTextConfig);
            text.options.text = label;
            text.visible = false;
            text.setText(label);
            this.view.addChild(text);
        }

        await game.utils.GameUtils.playMoveAnimation(text, {
            fromElement: fromElement,
            toElement: this.totalWinCounter,
            time: time,
            onStart: () => {
                onStart();
                text.visible = true
            },
            onFinish: () => {
                onFinish();
                text.visible = false
            }
        })

        await game.utils.delay(0);
        game.utils.PIXIUtils.remove(text);
    }

    async startCoinAnimation(): Promise<void> {
        for (let reelId = 0; reelId < CONST.COLUMNS; reelId++) {
            for (let rowId = 0; rowId < CONST.ROWS; rowId++) {
                const symbolData = this.store.gameData.reels[reelId][rowId];

                if (symbolData?.symbol == CONST.SYMBOLS.COIN && symbolData?.value) {
                    const symbol = this.reelset.getReel(reelId).getSymbol(rowId);
                    const  coinValue = symbolData.value * this.store.gameData.bet;
                    let value = this.store.toFormatMoney(coinValue);

                    if(symbolData.value == CONST.JACKPOT.GOLD_MULTIPLIER){
                        value = 'gold';
                    }

                    if(symbolData.value == CONST.JACKPOT.SILVER_MULTIPLIER){
                        value = 'silver';
                    }

                    if(symbolData.value == CONST.JACKPOT.BRONZE_MULTIPLIER){
                        value = 'bronze';
                    }



                    await game.utils.delay(this.TIME_DELAY_BEFORE_MOVE);

                    await this.playCoinAnimation(value, {
                        time: this.TIME_MOVE,
                        fromElement: symbol,
                        onStart: () => {
                            symbolData.value = null;
                            symbol.removeOverlayView();
                            game.emit(CoinAnimationComponent.events.FLY_START);
                        },
                        onFinish: () => {
                            this.store.gameData.visualWinAmount += coinValue;
                            game.emit('UI.UPDATED');
                            game.emit(CoinAnimationComponent.events.FLY_FINISH);
                            this.onChangeOrientation();
                        }
                    });
                }
            }
        }
    }


    async show() {
        this.isShowing = true;

        this.onChangeOrientation();
    }

    async hide() {
        await game.utils.delay(1000);
        this.isShowing = false;

        this.onChangeOrientation();
    }



    get store(): SlotGameStore {
        return <SlotGameStore>game.store;
    }

    getFSMHandlers(): any {
        return {
            SPIN: {
                exit: {
                    on: async () => {
                        if (this.store.gameData.bonusGame.isFinished()) {
                            await this.show();
                            await this.startCoinAnimation();

                            await this.hide();
                        }
                    }
                }
            }
        }
    }
}

//@ts-ignore
Game.src.component.CoinAnimationComponent = CoinAnimationComponent;